import { IActiveScheduleState } from './types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DiaryRootState } from 'app/appRoot/rootReducer';
import { IActiveBookingsState } from 'booking-creator/reducers/activeBookings/types';

const NS = 'activeScheduleSlice';

const initialState: IActiveScheduleState = {

};

const activeScheduleSlice = createSlice({
  name: 'activeScheduleSlice', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(loadTags.pending, (state, action) => {
    //     state.status = FetchingStatus.loading;
    //   })
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = activeScheduleSlice;
// Extract and export each action creator by name
export { actions as activeScheduleActions };
// Export the reducer, either as a default or named export
export default reducer;
